import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Srujana Kalyadapu',
    title: "Aspiring Business Analyst",
    desciption:" I am a driven and resourceful Business Analytics graduate from Purdue University with over three years of experience in data analytics, consulting, and supply chain management. ",
    image: 'SK.jpeg',
    resumePdf: resume
}
